import { render, staticRenderFns } from "./Proceso.vue?vue&type=template&id=641898c4&scoped=true"
import script from "./Proceso.vue?vue&type=script&lang=js"
export * from "./Proceso.vue?vue&type=script&lang=js"
import style0 from "./Proceso.vue?vue&type=style&index=0&id=641898c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641898c4",
  null
  
)

export default component.exports